var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.icon)?_c('v-icon',_vm._b({staticClass:"text--lighten-5"},'v-icon',_vm.icon_props,false),[_vm._v(" "+_vm._s(_vm.icon)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }